import __request__ from 'routing/request';
interface anyMap {
    readonly [_key: string]: unknown;
}
/**
 * Get existing theme overrides
 */
export function getThemeOverrides(): Promise<anyMap> {
    return __request__('GET', '/plugins/org.graylog.plugins.customization/theme', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Update existing theme overrides
 */
export function updateThemeOverrides(overrides?: anyMap, is_default?: boolean): Promise<anyMap> {
    return __request__('POST', '/plugins/org.graylog.plugins.customization/theme', overrides, { 'is_default': is_default }, {
        'Accept': ['application/json']
    });
}
/**
 * Delete existing theme overrides
 */
export function deleteThemeOverrides(delete_default?: boolean): Promise<anyMap> {
    return __request__('DELETE', '/plugins/org.graylog.plugins.customization/theme', null, { 'delete_default': delete_default }, {
        'Accept': ['application/json']
    });
}
/**
 * Returns true, if only a default color theme is present in the DB.
 */
export function hasOnlyDefaultThemeOverrides(): Promise<boolean> {
    return __request__('GET', '/plugins/org.graylog.plugins.customization/theme/only_defaults_exist', null, {}, {
        'Accept': ['application/json']
    });
}
